module.exports = __webpack_public_path__ + "media/images/icons/icons_large/28_camera-1c25048369227e295d7d6ecf62267954.png";